// When a signed-in session asks markStaffSignIn to activate an invited staff account, and how the session's own copy
// of the profile follows (docs/bugs/staff_sign_in_never_activates_BUG.md). Pure: src/stores/userStore.js wires it.
// The profile is read once at sign-in, before the server activates, so the session patches its copy instead of
// showing 'invited' until the next load.

/** Ask only for a staff account still 'invited', and never for an impersonated session (that is not them signing in). */
export function shouldActivateInvitedStaff({ isStaff, profile, impersonating }) {
  return isStaff === true && !impersonating && profile?.status?.accountStatus === 'invited'
}

/** Follow the server's answer, not who activated: a second tab is told 'active' without activating anything itself. */
export function isNowActive(reply) {
  return reply?.accountStatus === 'active'
}

/**
 * The profile as the server left it: 'active', the invitation consumed. In place, on purpose: App.vue watches
 * userStore.user by identity and re-runs the whole staff start-up for a new object, while a nested change only
 * reaches the computeds that read it.
 */
export function applyActivatedStatus(profile) {
  profile.status = { ...(profile.status || {}), accountStatus: 'active' }
  profile.invitation = null
  return profile
}
